import { useCallback, useMemo, useState } from "react";
import { Outlet } from "react-router";

import {
  TranscriptionConfiguration,
  TranscriptionOutletContext,
} from "../types/types";

export function TranscriptionLayoutPage() {
  const [mediaFile, setMediaFile] = useState<File | undefined>();
  const [transcriptionConfiguration, setTranscriptionConfiguration] =
    useState<TranscriptionConfiguration>({ transcriber: "machine" });

  const reset = useCallback(() => {
    setMediaFile(undefined);
    setTranscriptionConfiguration({ transcriber: "machine" });
  }, []);

  const context = useMemo<TranscriptionOutletContext>(
    () => ({
      mediaFile,
      setMediaFile,
      transcriptionConfiguration,
      setTranscriptionConfiguration,
      reset,
    }),
    [
      mediaFile,
      setMediaFile,
      transcriptionConfiguration,
      setTranscriptionConfiguration,
      reset,
    ],
  );

  return <Outlet context={context} />;
}
